// extracted by mini-css-extract-plugin
module.exports = {"content":"topbar-manage-users-popover_content__gp2yX"};